<template>
  <a-modal width="550px" :visible="visible" title="Refuse to Sign Written Warning" @cancel="closeModal">
    <signature
      :key="signatureKey"
      checkbox-label="I confirm that I issued the associate a written warning, and they have viewed it"
      ref="signatureRef"
      @checked="checked = $event"
      @save-signature="setSignatureId"
    />

    <template slot="footer">
      <div class="flex justify-content-between">
        <a-button @click="closeModal">Close</a-button>
        <a-button type="primary" :disabled="!checked" :loading="loading" @click="sign"> Sign </a-button>
      </div></template
    >
  </a-modal>
</template>

<script>
import Signature from '@/components/signature.vue'
import { UUID } from '@/utils/uuid'
import { Button, Modal, notification } from 'ant-design-vue'
import { createNamespacedHelpers } from 'vuex'

const { mapActions: profileActions } = createNamespacedHelpers('profile')

export default {
  components: {
    'a-modal': Modal,
    'a-button': Button,
    Signature
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    writeup_id: {
      type: Number,
      default: undefined
    }
  },
  data() {
    return {
      signature_id: undefined,
      signatureKey: UUID(),

      checked: false,

      loading: false
    }
  },
  computed: {
    adminAssociateSignature() {
      return this.$store.state.applicationState.associate.signature
    }
  },
  methods: {
    ...profileActions(['postSignWriteUp']),

    showNotification(type, message, description) {
      notification[type]({
        message,
        description
      })
    },

    closeModal() {
      this.checked = false
      this.signature_id = undefined
      this.signatureKey = UUID()
      this.$emit('update:visible', false)
      this.$emit('update:writeup_id', undefined)
    },

    setSignatureId(signatureId) {
      this.signature_id = signatureId
    },

    async sign() {
      this.loading = true

      try {
        await this.$refs.signatureRef.saveSignature()

        const payload = {
          signature_id: this.signature_id,
          writeup_id: this.writeup_id
        }

        await this.postSignWriteUp(payload)

        this.showNotification('success', 'Success', 'Written Warning Signed Successfully')

        this.closeModal()
      } catch (error) {
        this.showNotification('error', 'Error', typeof error === 'string' ? error : error.message)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
